import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import MailOutlined from "@ant-design/icons/MailOutlined";
import LockOutlined from "@ant-design/icons/LockOutlined";
import {
  emailValidation,
  minLengthValidation,
} from "../../../utils/formValidation";
import { recoverApi } from "../../../api/user.api";

//import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../../utils/constants";

import "./RecoverForm.scss";
//import SignIn from "../../../pages/Admin/SignIn/SignIn";

export default function RecoverForm() {
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    //password: "",
  });

  const [formValid, setFormValid] = useState({
    email: false,
    //password: false,
  });

  const [logging, setLogging] = useState(false);

  const changeForm = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const inputValidation = (e) => {
    const { type, name } = e.target;

    if (type === "email") {
      setFormValid({
        ...formValid,
        [name]: emailValidation(e.target),
      });
    }

    // if (type === "password") {
    //   setFormValid({
    //     ...formValid,
    //     [name]: minLengthValidation(e.target, 6),
    //   });
    // }
  };

  const login = async (e) => {
    //e.preventDefault();
    setLogging(true);
    //const passwordVal = inputs.password;
    if (!inputs.email) {
      notification["error"]({
        message: "El correo es obligatorio",
      });
      setLogging(false);
    } else {
      const result = await recoverApi(inputs);
      console.log(result);
      if (!result) {
        notification["error"]({
          message: "El servidor no se ha iniciado",
        });
        setLogging(false);
      } else if (!result.status) {
        notification["error"]({
          message: result.message,
        });
        setLogging(false);
      } else {
        notification["success"]({
          message: result.message,
          duration: 8,
        });
        setLogging(false);
        setDisabled(true);
      }
    }
    //console.log(result);
  };

  return (
    <Form className="login-form" onChange={changeForm} onFinish={login}>
      <br />

      <Form.Item>
        <Input
          prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          type="email"
          name="email"
          placeholder="Correo electronico"
          className="login-form__input"
          onChange={inputValidation}
        />
      </Form.Item>
      <br />
      <br />
      <Form.Item disabled={disabled}>
        <Button
          htmlType="submit"
          loading={logging}
          className="login-form__button"
          disabled={disabled}
        >
          Recuperar clave
        </Button>
      </Form.Item>
    </Form>
  );
}
